<small *ngIf="shouldShowError" class="form-control-error">
    {{ errorMessage }}
</small>